import { render, staticRenderFns } from "./menuGroups.vue?vue&type=template&id=9b26e332&scoped=true"
import script from "./menuGroups.vue?vue&type=script&lang=js"
export * from "./menuGroups.vue?vue&type=script&lang=js"
import style0 from "./menuGroups.vue?vue&type=style&index=0&id=9b26e332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b26e332",
  null
  
)

export default component.exports